var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",class:_vm.$route.params.type},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onPage),expression:"onPage"}],staticClass:"main-icon"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }